<template>
  <div>
    <base-header 
      v-once 
      :prevBtnShow="true"
      pageName="알림"></base-header>

    <section id="wrap">
      <div class="push" v-if="list.length > 0">
        <ul>
          <li v-for="item in list" :key="item.rn"
          @click="moveDetail(item);showDetail(item)" :class="[{'move' : item.scrnUrl != undefined}, {'cus-link' : item.dtlCnt > 0}, {'open' : item.isDetailShow == true}]">
            <strong>{{item.titl}}</strong>
            <em>{{item.timeAgo}}</em>
            <p>{{item.cntn}}</p>
            <template v-if="item.dtlCnt > 0">
              <div v-show="item.isDetailShow">
                  <span v-for="(cust, index) in getCustList(item)" 
                    :key="item.rn+index" 
                    @click.stop="moveCustDetail(cust)"
                    :class="{'to' : isCustDetail(cust)}">
                    {{cust.custNm}}</span>
              </div>
            </template>
          </li>
          <!-- <li v-for="item in list" :key="item.rn"
          @click="moveDetail(item);showDetail(item)" :class="[{'move' : item.scrnUrl != undefined}, {'cus-link' : item.dtlCnt > 0}, {'open' : item.isDetailShow == true}]">
            <strong>{{item.titl}}</strong>
            <em>{{item.timeAgo}}</em>
            <p>{{item.cntn}}</p>
            <template v-if="item.dtlCnt > 0">
              <div v-show="item.isDetailShow">
                  <span v-for="(cust, index) in getCustList(item)" 
                    :key="item.rn+index" >
                    {{cust.custNm}}</span>
              </div>
            </template>
          </li> -->
        </ul>
      </div>
      <infinite-loading
        @infinite="infiniteHandler"
        spinner="waveDots"
        ref="InfiniteLoading"
      >
        <div slot="no-more"></div>
        <div slot="no-results">
          <div class="search-resutl-None">
            <p>수신된 알림이 없습니다.</p>
          </div>
        </div>
      </infinite-loading>
    </section>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      list: [],
      page: 1,
      maxSqno: 0,
    };
  },
  methods: {
    infiniteHandler: function ($state) {
      var that = this;
      var parameters = {
        page: this.page,
        maxSqno: this.maxSqno
      };
      
      this.$api.notification
        .list(parameters)
        .then(function (data) {
          var listSize = data.listSize;
          if (listSize > 0) {
            that.list = that.list.concat(data.list);
            $state.loaded();
            that.page = data.req.page + 1;
            that.maxSqno = data.req.maxSqno;
            if (listSize < data.req.rowSize) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function (error) {
          alert(error.rtMsg);
          console.log(error);
        });
    },
    moveDetail: function(item) {
      var ppupYn = item.ppupYn;
      var scrnUrl = item.scrnUrl;
      if(typeof scrnUrl == "undefined") {
        return;
      }
      if(ppupYn == 'Y') {
        if(this.isOutlink(scrnUrl)) {
          this.$utils.nativeIf.outbound.outlink(scrnUrl);
        } else {
          this.$utils.nativeIf.outbound.newPage(scrnUrl);
        }
      } else {
        this.$router.push({path:scrnUrl}).catch(function() { });
      }
    },
    isOutlink: function(url) {
      var lowerUrl = url.toLowerCase();

      if(lowerUrl.startsWith("https:")) {
        return true;
      }
      if(lowerUrl.startsWith("http:")) {
        return true;
      }
      return false;
    },
    getCustList: function(item) {
      var dtlJsonString = item.dtlJsonString;
      return JSON.parse(dtlJsonString);
    },
    isCustDetail: function(detail) {
      var kwkkey = '';
      var custDiv = '';
      if(detail.custsrno != 0) {
        kwkkey = detail.custsrno;
        custDiv = 'SCD02';
      }
      if(detail.kwkey != null && detail.kwkey != 0) {
        kwkkey = detail.kwkey;
        custDiv = 'SCD01';
      }

      if(kwkkey == '' || custDiv == '') {
        return false;
      }

      return true;
    },
    moveCustDetail: function(detail) {
      var kwkkey = '';
      var custDiv = '';
      if(detail.custsrno != 0) {
        kwkkey = detail.custsrno;
        custDiv = 'SCD02';
      }
      if(detail.kwkey != null && detail.kwkey != 0) {
        kwkkey = detail.kwkey;
        custDiv = 'SCD01';
      }

      if(kwkkey == '' || custDiv == '') {
        return;
      }

      var url = "/myCstmr/myCstmrView?userId="+detail.userid+"&kwkkey="+kwkkey+"&custDiv="+custDiv;
      this.$utils.nativeIf.outbound.newPage(url);
    },
    showDetail: function(item) {
      item.isDetailShow = !item.isDetailShow;
       this.$forceUpdate(); 
    },
    deleteAlarm: function(item) {
      if(!confirm("알림 삭제하시겠습니까?")){
         return;
      }

      var that = this;
      var parameters = {};
      parameters.pushSqno = item.pushSqno;

      this.$api.notification
        .delete(parameters)
        .then(function () {
          that.$router.go(that.$router.currentRoute);
        })
        .catch(function (error) {
          alert(error.rtMsg);
          console.log(error);
        });
    },
    allDelete: function() {
      if(!confirm("알림 삭제하시겠습니까?")){
         return;
      }
      
      var that = this;
      var parameters = {};

      this.$api.notification
        .allDelete(parameters)
        .then(function () {
          that.$router.go(that.$router.currentRoute);
        })
        .catch(function (error) {
          alert(error.rtMsg);
          console.log(error);
        });
    }
  },
  beforeUpdate: function () {},
};
</script>
 